import React from "react";
import "./styles/case.css";
import { Link, useNavigate } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import { case_1 } from "../../helper/caseData";
const Case = () => {
  const navigate = useNavigate();
  return (
    <section className="case-section">
      <div className="container case-container">
        <p className="case-heading">Blogs</p>
        <h2>Real Results. Real Growth. Real Opinion.</h2>
        <p>
        Stay informed with the latest trends, tips, and strategies in app monetization, user engagement, and survey tech — curated by the Real Opinion team.
        </p>
        <div className="case-content">
          <div className="case-left">
            <div className="case-line"></div>
            <div className="left-case-content">
            <img src="images/left-case.webp" alt="" />
              <div className="sub-para-left-case">
                <h3>
                  {case_1.title}
                </h3>
                <p>
                  {case_1.subTitle}
                </p>
              </div>
              <div className="read-more">
                <Link to={"/case-studies"}>Read More</Link>
              </div>
            </div>
          </div>
          <div className="case-right">
            <div className="left-case-content">
            <img src="images/right-case.webp" alt="" />
            <div className="sub-para-left-case">
                  <h3>
                  21 Proven Ways To Increase Mobile App Downloads in 2025
                  </h3>
                  <p>
                  With nearly 9 million mobile apps worldwide, the challenge of standing out and increasing your app's downloads can be daunting. If you've been struggling with low download rates, you're probably wondering why users aren't flocking to your app. To address this issue, let's explore ways to increase mobile app downloads.
                  </p>
                </div>
              <div className="read-more">
                <Link to={"/case-studies"}>Read More</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="see-more">
        <Link to={"/case-studies"}> See More</Link> <IoIosArrowDown></IoIosArrowDown>
      </div>
    </section>
  );
};

export default Case;
